'use client';

import { createContext, ReactNode, useContext, useMemo } from 'react';
import { Api } from './';
import { makeProjectKeys } from '@/app/hooks/query-keys';
import { getApiUrl } from './utils';

const ApiContext = createContext<Api | null>(null);

export function ApiProvider({
  children,
  projectStageId,
}: {
  children: ReactNode;
  projectStageId?: number;
}) {
  const api = useMemo(() => {
    return new Api({ baseUrl: getApiUrl(), projectStageId });
  }, [projectStageId]);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): Api {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi must be used within <ApiProvider>');
  return api;
}

export function useProjectKeys() {
  const { projectStageId } = useApi();
  return useMemo(() => makeProjectKeys(projectStageId), [projectStageId]);
}
